import type { TrackEvent } from '../../core';
import type { ParameterFields } from './parameter-types';

/** 只维护系统语义，商户、商品、订单等业务字段由宿主登记。 */
export const SYSTEM_FIELDS: ParameterFields = {
  _uuid: {}, _sessionId: { aliases: ['_SID'] }, _is_new_visit: {}, _uuidMdKey: {},
  _shopCart: {}, _platform: {}, _action: { aliases: ['action'] },
  _actionType: { aliases: ['actionType'] }, _timeStamp: {},
  _currentURL: { aliases: ['currPage', 'pageUrl', 'pagePath'] }, _ref: { aliases: ['referrer'] },
};

export function systemDefaults(event: TrackEvent): Record<string, unknown> {
  return {
    _uuid: event.uuid, _sessionId: event.sessionId,
    _is_new_visit: event.isNewVisit, _uuidMdKey: event.isNewVisit,
    _shopCart: 'web', _action: event.eventName, _actionType: 1, _timeStamp: event.timestamp,
  };
}
